export interface DauerGruppe {
  ids: string[];
  beschreibung: string;
}

const dauerGruppen: DauerGruppe[] = [
  { ids: ['1', '2'], beschreibung: 'bis 1 Woche' },
  { ids: ['1', '2', '3'], beschreibung: 'bis 1 Monat' },
  { ids: ['1', '2', '3', '4'], beschreibung: 'bis 3 Monate' },
  { ids: ['1', '2', '3', '4', '5'], beschreibung: 'bis 6 Monate' },
  { ids: ['1', '2', '3', '4', '5', '6'], beschreibung: 'bis 1 Jahr' }
];

export const dauerGruppenWeiterbildungsangebote: DauerGruppe[] = [
  ...dauerGruppen,
  { ids: ['7', '8', '9'], beschreibung: 'mehr als 1 Jahr' }
];

export const dauerGruppenUteAngebote: DauerGruppe[] = [
  ...dauerGruppen,
  { ids: ['7'], beschreibung: '1 - 2 Jahre' },
  { ids: ['8'], beschreibung: '2 - 3 Jahre' },
  { ids: ['9'], beschreibung: 'mehr als 3 Jahre' }
];
